import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import useSignupStore from "../../../store/SignUpStore";
import { accountSchema } from "../../../utils/accountSchema";

const AccountInfoPage = () => {
    const { loginId, password, setAccountInfo } = useSignupStore();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
        watch,
    } = useForm({
        resolver: zodResolver(accountSchema),
        defaultValues: {
            loginId: loginId || "",
            password: password || "",
            passwordConfirm: "",
        },
        mode: "onChange",
    });


    const onSubmit = (data) => {
        setAccountInfo({
            loginId: data.loginId,
            password: data.password,
        });
        navigate("/signup/personal-info");
    };

    return (
        <div className="sch-awrap sch-awrap--wide">
            <div className="sch-no">JOIN — 1분이면 끝나요</div>
            <h1>회원가입</h1>

            <form onSubmit={handleSubmit(onSubmit)} className="sch-aform">
                <div className="sch-fsec" style={{ borderTop: 0, paddingTop: 0, marginTop: 0 }}>
                    <span className="sch-t">02 — 계정</span>

                    <label className={`sc-field${errors.loginId ? " sc-field--error" : ""}`}>
                        <span className="sc-field__label">아이디<span className="sc-req">*</span></span>
                        <input {...register("loginId")} type="text" className="sc-input" placeholder="아이디 입력" />
                        {errors.loginId && <span className="sc-field__error">{errors.loginId.message}</span>}
                    </label>

                    <div className="sch-fgrid2">
                        <label className={`sc-field${errors.password ? " sc-field--error" : ""}`}>
                            <span className="sc-field__label">비밀번호<span className="sc-req">*</span></span>
                            <input {...register("password")} type="password" className="sc-input" placeholder="비밀번호 입력" />
                            {errors.password && <span className="sc-field__error">{errors.password.message}</span>}
                        </label>

                        <label className={`sc-field${errors.passwordConfirm ? " sc-field--error" : ""}`}>
                            <span className="sc-field__label">비밀번호 재확인<span className="sc-req">*</span></span>
                            <input {...register("passwordConfirm")} type="password" className="sc-input" placeholder="한 번 더 입력" />
                            {errors.passwordConfirm && <span className="sc-field__error">{errors.passwordConfirm.message}</span>}
                        </label>
                    </div>
                </div>

                <button
                    type="submit"
                    className="sch-bigbtn"
                    style={{ justifyContent: "center", marginTop: "6px" }}
                    disabled={!isValid}
                >
                    다음
                </button>

                <div className="sch-alinks">
                    <button type="button" className="sch-alink" onClick={() => navigate("/signup")}>
                        ← 약관 동의로 돌아가기
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AccountInfoPage;
